// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"7fb88f30","14":"3499866d","624":"7162a8fb","749":"ac91a603","995":"9947bdd1"}[chunkId] + ".chunk.js";
};